// src/views/turnos/TurnoEditView.js
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Container, Form, Button, Row, Col, Table } from 'react-bootstrap';
import { fetchHorarios } from '../../../controller/HorarioController';
import {
  updateTurnoSemanal,
  deleteTurnoSemanal,
} from '../../../controller/TurnoController';
import TurnoSemanal from '../../../models/Turno';

function TurnoEditView() {
  const navigate = useNavigate();
  const location = useLocation();
  const turnoState = location.state?.turno;

  const [horarios, setHorarios] = useState([]);
  const [turno, setTurno] = useState(new TurnoSemanal({}));

  const dias = [
    'lunes',
    'martes',
    'miercoles',
    'jueves',
    'viernes',
    'sabado',
    'domingo',
  ];

  useEffect(() => {
    if (!turnoState) {
      navigate('/turno'); // Redirige si no hay datos
      return;
    }

    const cargarDatos = async () => {
      try {
        const dataHorarios = await fetchHorarios();
        setHorarios(dataHorarios);

        const nuevoTurno = {
          id: turnoState.id,
          nombre: turnoState.nombre,
          lunes_id: turnoState.lunes?.id || '',
          martes_id: turnoState.martes?.id || '',
          miercoles_id: turnoState.miercoles?.id || '',
          jueves_id: turnoState.jueves?.id || '',
          viernes_id: turnoState.viernes?.id || '',
          sabado_id: turnoState.sabado?.id || '',
          domingo_id: turnoState.domingo?.id || '',
        };

        setTurno(nuevoTurno);
      } catch (error) {
        console.error('Error al cargar datos:', error);
      }
    };

    cargarDatos();
  }, [turnoState, navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setTurno({
      ...turno,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        nombre: turno.nombre,
        lunes_id: turno.lunes_id,
        martes_id: turno.martes_id,
        miercoles_id: turno.miercoles_id,
        jueves_id: turno.jueves_id,
        viernes_id: turno.viernes_id,
        sabado_id: turno.sabado_id,
        domingo_id: turno.domingo_id,
      };
      await updateTurnoSemanal(turno.id, payload);
      navigate(-1);
    } catch (error) {
      console.error('Error al actualizar el turno:', error);
    }
  };

  const handleDelete = async () => {
    if (!window.confirm('¿Estás seguro de que deseas eliminar este turno?')) return;

    try {
      await deleteTurnoSemanal(turno.id);
      navigate(-1);
    } catch (error) {
      console.error('Error al eliminar el turno:', error);
    }
  };

  return (
    <Container className="mt-4">
      <Row className="align-items-center mb-4">
        <Col><h1>Editar Turno Semanal</h1></Col>
      </Row>

      {/* Vista previa en tabla */}
      <Row className="mb-4">
        <Col>
          <h4>Vista previa del turno semanal</h4>
          <Table bordered responsive>
            <thead>
              <tr>
                {dias.map((dia) => (
                  <th key={dia}>{dia.charAt(0).toUpperCase() + dia.slice(1)}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              <tr>
                {dias.map((dia) => {
                  const horarioId = turno[`${dia}_id`];
                  const horario = horarios.find(h => h.id === parseInt(horarioId));
                  return (
                    <td key={dia}>
                      {horario
                        ? `${horario.nombre} (${horario.hora_inicio} - ${horario.hora_fin})`
                        : <em>Sin asignar</em>}
                    </td>
                  );
                })}
              </tr>
            </tbody>
          </Table>
        </Col>
      </Row>

      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Label>Nombre del Turno</Form.Label>
          <Form.Control
            type="text"
            name="nombre"
            value={turno.nombre}
            onChange={handleChange}
            required
          />
        </Form.Group>

        {dias.map((dia) => (
          <Form.Group className="mb-3" key={dia}>
            <Form.Label>Horario para {dia.charAt(0).toUpperCase() + dia.slice(1)}</Form.Label>
            <Form.Select
              name={`${dia}_id`}
              value={turno[`${dia}_id`] || ''}
              onChange={handleChange}
              required
            >
              <option value="">-- Selecciona un horario --</option>
              {horarios.map((horario) => (
                <option key={horario.id} value={horario.id}>
                  {horario.nombre} ({horario.hora_inicio} - {horario.hora_fin})
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        ))}

        <Button variant="primary" type="submit" className="me-2">
          Guardar Cambios
        </Button>
        <Button variant="danger" className="me-2" onClick={handleDelete}>
          Eliminar Turno
        </Button>
        <Button variant="secondary" onClick={() => navigate(-1)}>
          Cancelar
        </Button>
      </Form>
    </Container>
  );
}

export default TurnoEditView;
